import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Icon, Layout, Menu } from 'antd';
import { setUserInfo } from '@/redux/actions/userInfo';
import { addTag } from '@/redux/actions/tagList';
import { menus } from '@/router/menus';
import { routes } from '@/router/routes';
import { findPathHierarchy } from '../../utils';

const { Sider } = Layout;
const { SubMenu } = Menu;

class SideMenu extends Component {
	state = { menuSelected: this.props.history.location.pathname };

	handleFilter = permission => {
		return !permission || permission.some(el => this.props.userInfo?.roles?.includes(el));
	};

	handClickTag(currentLink, parent) {
		const { path, title } = currentLink;
		this.props.history.push(currentLink.path);
		for (let i = 0; i < routes.length; i++) {
			if (path === routes[i].path) {
				let obj = { path, title, component: routes[i].component };
				this.props.addTag(parent ? Object.assign({}, obj, { parent: parent.title }) : obj);
			}
		}
	}

	renderMenu = data => {
		return data.map(item => {
			if (item.children && item.createChildrenMenu !== false) {
				return (
					this.handleFilter(item.permission) && (
						<SubMenu
							key={item.title}
							title={
								<span>
									{item.icon ? <Icon type={item.icon} /> : ''}
									<span>{item.title}</span>
								</span>
							}
						>
							{this.renderMenu(item.children)}
						</SubMenu>
					)
				);
			}
			return (
				(this.handleFilter(item.permission) && item.show !== false) && (
					<Menu.Item key={item.path}>
						<Link to={item.path} onClick={() => this.handClickTag(item)}>
							{item.icon ? <Icon type={item.icon} /> : ''}
							<span>{item.title}</span>
						</Link>
					</Menu.Item>
				)
			);
		});
	};

	pathHierarchy = (location, data) => {
		return findPathHierarchy(data, location.pathname);
	};

	render() {
		const menuSelected = this.props.history.location.pathname;
		const hierarchy = this.pathHierarchy(this.props.history.location, menus);
		const menuOpened = `/${menuSelected.split('/')[1]}`;
		const expandKey = hierarchy?.[0]?.title || `/${menuSelected.split('/')[1]}`;
		const type = this.props.theme.type;
		const { collapse } = this.props;
		return (
			<Sider trigger={null} collapsible collapsed={collapse.isCollapsed} theme={type} className="app-sider">
				<div className="logo" style={{ color: type === 'dark' ? '#ffffffa6' : '' }}>
					{/*<img src={LOGO} alt="" className="src" />*/}
					IMA
				</div>
				<Menu style={{ height: '50px' }} theme={type} defaultOpenKeys={[expandKey]} defaultSelectedKeys={[menuSelected]}
							selectedKeys={[menuOpened]} mode="inline">
					{this.renderMenu(menus)}
				</Menu>
			</Sider>
		);
	}
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => ({
	setUserInfo: data => {
		dispatch(setUserInfo(data));
	},
	addTag: data => {
		dispatch(addTag(data));
	}
});
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(SideMenu));
